<template>
    <div>
        <span v-if="!forecastWindow"> {{ formDate(forecast.startDate) }} > {{ formDate(forecast.endDate) }} </span>
        <span v-else-if="forecastWindow && !forecastWindow.startDate"> {{ formDate(forecast.startDate) }} > {{ formDate(forecast.endDate) }} </span>
        <span v-else-if="forecastWindow && forecastWindow.startDate">
            {{ formDate(forecastWindow.startDate) }} > {{ formDate(forecastWindow.endDate) }}
        </span>
    </div>
</template>
<script>
import { formatDateOrdinal as fDate } from "@/components/forecasts/utils/utilis";
import { PROFILES } from "@/plugins/AccessUserPlugin";

export default {
    props: {
        forecast: {
            type: Object,
            required: true
        },
        forecastWindow: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            PROFILES
        };
    },
    methods: {
        formDate(date) {
            return fDate(date);
        },
        hasAccessByProfile(profile) {
            return this.$accessUser.hasAccessByProfile(profile);
        }
    }
};
</script>
<style scoped lang="scss">
span {
    text-transform: capitalize;
    font-size: 19px;
    @media (max-width: 1440px) {
        font-size: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// DateInfosSimple.vue?637ec048